import { useBlock } from './useBlock.js';
/**
 * Returns the block style (if available)
 *
 * @param node DomNode
 * @returns
 */
export function useBlockBorder(node) {
    var _a;
    const { attributes } = useBlock(node);
    return (_a = attributes === null || attributes === void 0 ? void 0 : attributes.styleConfig) === null || _a === void 0 ? void 0 : _a.border;
}
